import { useEffect, useState } from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';

import config from '../config';

export default function CommunityArticles() {
  const [search, setSearch] = useState('');
  const [communityArticles, setCommunityArticles] = useState([]);
  const showResultText = search.length > 0;

  useEffect(() => {
    if (search.length) {
      const searchTerm = search.toLowerCase();
      setCommunityArticles(
        communityArticles.filter(({ name, author }) => {
          return (
            name.toLowerCase().includes(searchTerm) ||
            (author && author.toLowerCase().includes(searchTerm))
          );
        }),
      );
    } else {
      const fetchArticles = async () => {
        try {
          const articlesReq = await axios.get(
            `${config.contentBaseUrl}/content/items/CSN?fields={"name":1, "author":1,"date":1,"url":1,"more_info":1}&sort={"_created":-1}`,
          );
          setCommunityArticles(articlesReq.data);
        } catch (err) {
          console.log(err);
        } finally {
          //
        }
      };

      fetchArticles();
    }
  }, [search]);

  return (
    <section className="py-5 light-background">
      <Container>
        <h3 className="mb-4">Read About Community Support Networks</h3>

        <div className="row">
          <div className="col-lg-8 col-md-8 col-12">
            <div className="text-muted fw-bold">&nbsp;</div>
          </div>
          <div className="col-lg-4 col-md-4 col-12">
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search by community or author"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value.trim());
              }}
            />
          </div>
        </div>

        <Row className="g-4">
          {communityArticles.length === 0 ? (
            <Col>
              <p className="text-center text-muted">No articles found.</p>
            </Col>
          ) : (
            communityArticles.map(
              ({ name, url, author, date, more_info = '' }, idx) => (
                <Col md={6} lg={4} key={idx}>
                  <Card className="h-100 shadow-sm p-2 border-0">
                    <Card.Body>
                      <Card.Title className="fw-normal">
                        <a
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          {name}
                        </a>
                      </Card.Title>
                      <Card.Text>
                        {author && (
                          <>
                            {author} <br />
                          </>
                        )}
                        {date && <>{date}</>}
                      </Card.Text>
                      {more_info && (
                        <div
                          dangerouslySetInnerHTML={{ __html: more_info }}
                        ></div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ),
            )
          )}
        </Row>
      </Container>
    </section>
  );
}
